import React from "react";
import { Divider, Radio, RadioChangeEvent, Typography } from "antd";
import { useAIAssessmentContext } from "../../../../Context/AIAssessmentContext/AIAssessmentContext";
import "./aiAssessmentAnswerInputs.scss";
import useAiAssessmentQuestionNavigation from "../../hooks/useAiAssessmentQuestionNavigation";

const MCQAnswerInput: React.FC = () => {
  const {
    currentStep,
    aiAssessmentQuestions,
    isRoundFinished,
    temporaryAnswer,
  } = useAIAssessmentContext();

  const { saveTemporaryAnswer } = useAiAssessmentQuestionNavigation();

  const question = aiAssessmentQuestions[currentStep];
  const options = question.options;
  const isDisabled = isRoundFinished || question.answer !== null;
  const userAnswer = question.answer || temporaryAnswer;

  const onOptionChange = (e: RadioChangeEvent) => {
    const isSameAnswer = e.target.value === userAnswer;
    if (isSameAnswer) {
      saveTemporaryAnswer(null);
    } else {
      saveTemporaryAnswer(e.target.value);
    }
  };

  return (
    <div
      className="mcq-answer-input"
      style={{
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
      }}
    >
      <Radio.Group
        onChange={onOptionChange}
        value={userAnswer}
        disabled={isDisabled}
      >
        {options.map((option, index) => (
          <Radio
            key={index}
            value={option}
            className="mcq-option"
            checked={userAnswer === option}
            onClick={(e) => {
              if (userAnswer === option) {
                onOptionChange({ target: { value: null } } as RadioChangeEvent);
              }
            }}
          >
            {option}
          </Radio>
        ))}
      </Radio.Group>

      {isRoundFinished && (
        <div className="ai-assessment-answer-mcq-input-result-container">
          <div className="ai-assessment-section-title">
            <Typography.Title
              level={5}
              style={{ margin: "0px", fontSize: "14px" }}
            >
              Your Answer
            </Typography.Title>
          </div>
          <Divider style={{ margin: "0px" }} />
          <div className="ai-assessment-answer-mcq-input-result">
            <Typography.Text strong>
              {userAnswer ? userAnswer : "No answer provided"}
            </Typography.Text>
          </div>
        </div>
      )}
    </div>
  );
};

export default MCQAnswerInput;
